module.exports = __webpack_public_path__ + "static/media/TapOfWarLogo.48dbff7b.png";